<template>
    <div class="main-bg">
        <div class="flex flex-col flex-auto w-full">
            <div class="flex flex-col flex-auto">
                <div class="login-outlet">
                    <div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0 ng-tns-c4007536743-101">
                        <div class="relative hidden md:flex flex-auto items-center justify-center w-1/2 h-full p-16 lg:px-28 overflow-hidden bg-gray-800 dark:border-r ng-tns-c4007536743-101">
                            <span><span style="" class="p-1"><img src="/static/images/Digicollect_Logo.svg" alt="DigiHelp" class="digiadmin-logo" style="width: 40px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> </span></span>
                            <div style="width: 100%;">
                                <div>
                                    <span class="fs-30 fw-800" style="color: #fff;">Streamlining Success!</span>
                                </div>
                                <hr class="mt-5">
                                <div v-if="activediv == 'forgot password'">
                                    <div class="mt-4 px-8">
                                        <img src="/static/images/forgot-password.svg" alt="" width="75%">
                                    </div>
                                    <div class="mt-8">
                                        <span class="fs-14" style="color: #fff;">
                                            No worries! Set your new password following these simple steps.
                                        </span>
                                    </div>
                                </div>
                                <div v-else-if="activediv == 'verify otp'">
                                    <div class="mt-4 px-8">
                                        <img src="/static/images/forgot-password.svg" alt="" width="75%">
                                    </div>
                                    <div class="mt-8">
                                        <span class="fs-14" style="color: #fff;">
                                            No worries! Set your new password following these simple steps.
                                        </span>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="mt-4 px-8">
                                        <img src="/static/images/newlogin.svg" alt="" width="100%">
                                    </div>
                                    <div class="mt-8">
                                        <span class="fs-14" style="color: #fff;">
                                            An integrated ticketing system that manages workflow and 
                                            communication with customers and users. Helps in tracking
                                            tickets and their progress in the real time
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="md:flex md:items-center md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card ng-tns-c4007536743-101">
                            <span class="text-default-blue crm-right-logo" style="font-size: 26px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;padding-right: 30px;">
                                <span style="" class="px-1 mr-1"><img src="/static/images/help_whitelogo.svg" alt="DigiHelp" class="digiadmin-logo" style="width: 40px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> </span>
                                DigiHelp
                            </span>
                            <div style="width: 100%;">
                            <div class="right-box">
                                <div v-if="activediv == 'login'">
                                    <div style="text-align: center !important;">
                                        <span class="text-white text-center fs-30 fw-800">
                                            Sign 
                                        </span>
                                        <span class="text-white text-center fs-30 fw-800" style="border-bottom: 4px solid #fff;">In</span>
                                    </div>
                                    <!-- <hr style="margin-left: 203px !important;width: 24px !important;margin-top: -6px !important;"> -->
                                    <div v-if="enter_email_screen">
                                        <!--p class="text-grey-default mb-10">Need an Account? <span class="font-weight-bold" style="cursor: pointer; color: #005dae !important;" @click="registerUser">Click here</span> to Sign up</p-->
                                        <!-- <p class="text-default-heading mb-2">Account Type</p>
                                        <div class="d-flex mb-5">
                                            <div class="form-check form-check-inline">
                                                <label class="form-check-label check-label-dc mr-2">
                                                    <input
                                                    class="form-check-input"
                                                    type="radio"
                                                    name="accountType"
                                                    v-validate="'required'"
                                                    value="Personal"
                                                    v-model="account_type"
                                                    />
                                                    <span class="radio-icon"></span>
                                                    <span
                                                    class="d-flex fw-600 pt-1"
                                                    style="font-size: 12px !important;color: #3f3f3f;"
                                                    >Personal</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="form-check-label check-label-dc">
                                                    <input
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="accountType"
                                                        v-validate="'required'"
                                                        value="Business"
                                                        v-model="account_type"
                                                    />
                                                    <span class="radio-icon"></span>
                                                    <span
                                                        class="d-flex fw-600 pt-1"
                                                        style="font-size: 12px !important;color: #3f3f3f;"
                                                    >Business</span>
                                                </label>
                                            </div>
                                        </div> -->
                                    </div>
                                    <form action="javascript:;">
                                        <div v-if="enter_email_screen" class="mt-6">
                                            <div style="height: 180px;">
                                                <p class="text-default-heading mb-3 text-white fw-600">Email Address<span class="star ml-1">*</span></p>
                                                <div class="w-100" v-if="oldlogin_id">
                                                    <div class="d-flex justify-content-end align-items-center">
                                                        <input type="text" autocomplete="off" @keyup.enter="goToNext('login')" class="digi-form-full-bordered mb-2" autofocus name="userid" placeholder="Enter Email Address" @input="goToNext('login')" v-model="form.login_id">
                                                        <!-- <div>
                                                            <img src="/static/images/check-fill.svg" width="20px" style="margin-left: -35px;margin-bottom: 6px">
                                                        </div> -->
                                                    </div>
                                                </div>
                                                <div class="w-100" v-if="login_id_true">
                                                    <div class="d-flex justify-content-end align-items-center">
                                                        <input type="text" autocomplete="off" @keyup.enter="goToNext('login')" class="digi-form-full-bordered mb-2" autofocus name="userid" placeholder="Enter Email Address" @input="checkUserIdback" v-model="form.login_id">
                                                        <div>
                                                            <img src="/static/images/check-fill.svg" width="20px" style="margin-left: -35px;margin-bottom: 6px">
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- v-show="errors.has('userid')"  -->
                                                <span class="text-danger fw-600 fs-14 mb-5" style="text-transform: none !important;" v-if="is_email_valid_text && form.login_id != ''">Please enter a valid Email Address</span>
                                                <span v-if="is_email_phone_valid" class="text-danger fw-600 fs-14 mb-5" style="text-transform: none !important;">{{is_email_phone_valid_text}}</span>
                                            </div>
                                            <!-- <div > -->
                                                <div v-if="login_id_true" class="forgot-password-button mt-8" style="text-align: center;">
                                                    <button class="btn newcancel text-capitalize fs-14 mr-5" type="button" @click="checkUserIdEmpty">Cancel</button>
                                                    <!-- v-if="!login_btn_disable" <button class="btn newcancel text-capitalize fs-14 mr-5" type="button">Cancel</button> -->
                                                    <button class="btn newsign-in text-capitalize fs-14" :disabled="login_id_true" type="button" @click="goToNext('login')">Sign In</button>
                                                </div>
                                            <!-- </div> -->
                                            <div v-else class="mt-8 d-flex justify-content-end">
                                                <!-- <button v-if="login_id_true" class="btn newcancel text-capitalize fs-14 mr-3" type="button" @click="checkUserIdEmpty">Cancel</button> -->
                                                <!-- v-if="!login_btn_disable" <button class="btn newcancel text-capitalize fs-14 mr-5" type="button">Cancel</button> -->
                                                <button class="btn newsign-in text-capitalize fs-14" :disabled="!login_id_true" type="button" @click="goToNext('login')">Sign In</button>
                                            </div>
                                            <!-- <div v-else class="mt-8 d-flex justify-content-end" style="position: relative;float:right;">
                                                <button class="btn newsign-in" disabled>Checking</button>
                                                <hollow-dots-spinner style="position: absolute;margin: 0;top: 28px;width: 160px !important;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                            </div> -->
                                        </div>
                                        <div v-if="user_not_verified" class="mt-6">
                                            <h1 v-if="login_type == 'email'" class="fs-14 mb-6 font-weight-bold text-white"><span class="text-white"><img src="/static/images/author-img.svg" alt="" width="34px">{{form.login_id}}</span></h1>
                                            <h1 v-if="login_type == 'phone'" class="fs-14 mb-6 font-weight-bold text-white"><span class="text-white"><img src="/static/images/author-img.svg" alt="" width="34px">{{form.login_id}}</span></h1>
                                            <div class="text-center" style="max-width: 380px">
                                                <div class="mb-2 ml-auto mr-auto" style="max-width: 230px">
                                                    <img style="width: 100%;" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/duck.svg" alt="Duck" />
                                                </div>
                                                <p class="text-white mb-2" style="font-size: 20px; font-weight: 800;">Verification Pending!!</p>
                                                <p class="text-white mb-2" style="font-size: 14px;">Your Verification link has been expired, Resend Link to verify</p>
                                                <div class="mt-4">
                                                    <div class="forgot-password-button" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize mb-5 mr-5" :disabled="resend_btn_disable" @click="cancelResendLink">Cancel</button>
                                                        <button class="btn newsign-in mb-5 text-capitalize" :disabled="resend_btn_disable" style="min-width: 110px; width: 160px !important;" @click="resendUserVerifyLink">Resend Link 
                                                            <hollow-dots-spinner v-if="resend_btn_disable" style="position: absolute;margin: 0;top: 25px;width: 160px !important;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                        </button>
                                                    </div>
                                                    <div v-if="resend_verification_link_success" class="text-default-blue fs-14 mt-2">{{resend_verification_link_success}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="enter_pass_screen" class="mt-6">
                                            <h1 v-if="login_type == 'email'" class="fs-14 mb-6 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                            <h1 v-if="login_type == 'phone'" class="fs-14 mb-6 font-weight-bold text-white"><img src="/static/images/author-img.svg" alt="" width="34px"> <span class="text-white">{{form.login_id}}</span></h1>
                                            <div v-if="!sign_in_using_otp">
                                                <p class="text-default-heading mb-5 text-white fw-600">Enter Password<span class="star ml-1">*</span></p>
                                                <div class="d-flex">
                                                    <input v-if="!showPassword" style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false" type="password"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password" name="password">
                                                    <input v-else type="text" style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password" name="password">
                                                    <span v-if="!showPassword" style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 20px;">
                                                    </span>
                                                    <span v-else style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 20px;">
                                                    </span>
                                                </div>
                                                <p v-if="password_error_text" class="text-danger mb-5">{{password_error_text}}</p>
                                                <p class="default-link mb-5 text-white" style="color: #fff !important;text-align: end;"><span @click="forgotPassword" class="pointer">Forgot Password ?</span></p>
                                                <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                    <button class="btn newcancel text-capitalize mr-5" :disabled="signedIn" @click="cancelPassScreen">Cancel</button>
                                                    <button :disabled="signedIn || form.password == ''" class="btn newsign-in text-capitalize" @click="loginUsingPassword('one-step')">Sign In
                                                        <hollow-dots-spinner v-if="signedIn" style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                    </button>
                                                </div>
                                                <div v-if="signedIn" style="text-align: center;" class="mt-6">
                                                    <p class="fs-14 mt-0 fw-600 pointer default-link" style="color: #fff !important;">Sign in using OTP</p>
                                                </div>
                                                <div v-else style="text-align: center;" class="mt-6">
                                                    <p class="fs-14 mt-0 fw-600 pointer default-link" style="color: #fff !important;" @click="goToOtpLogin('send')" >Sign in using OTP</p>
                                                </div>
                                            </div>
                                            <div v-if="sign_in_using_otp">
                                                <span class="text-default-heading text-white pb-6 fs-12 fw-600">Enter 6-Digit OTP Code*</span>
                                                <div>
                                                    <div class="d-flex align-items-start mt-2">
                                                        <div class="" @keyup.enter="loginUsingOtp('one-step')">
                                                            <v-otp-input
                                                            ref="otpInput"
                                                            :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                            separator=""
                                                            :num-inputs="6"
                                                            :should-auto-focus="true"
                                                            :is-input-num="true"
                                                            @on-complete="otpEntered"
                                                            @on-change="otpChangeDetected"
                                                            />
                                                            <div class="d-flex">
                                                                <div style="width: 190px;" class="pt-2">
                                                                    <span class="text-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                                </div>
                                                                <div style="color: #3f3f3f" class="ml-2 mt-2">
                                                                    <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                                    <br>
                                                                    <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                                </div>
                                                                <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                            </div>
                                                            <!-- <div class="mt-2">
                                                                <span style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                                <div style="color: #fff" class="mt-2">
                                                                    <button class="btn resend-code text-capitalize" style="min-width: 110px; width: 160px !important;" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                                    <br>
                                                                    <span v-if="countdown > 0"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                                </div>
                                                                <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                            </div> -->
                                                        </div>
                                                        <!-- <div>
                                                            <div style="color: #3f3f3f">
                                                                <button class="btn btn-new-primary pl-3 pr-3" style="min-width: 110px; width: 160px !important;" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                                <br>
                                                                <span v-if="countdown > 0"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                            </div>
                                                            <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                        </div> -->
                                                    </div>
                                                    <div v-if="resend_code_success_text" class="mt-2">
                                                        <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                                    </div>
                                                    <div v-if="otp_error_text" class="mt-2">
                                                        <span class="text-danger fs-14">{{otp_error_text}}</span>
                                                    </div>
                                                </div>
                                                <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                    <button class="btn newcancel text-capitalize mr-5" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                    <button class="btn newsign-in text-capitalize" :disabled="signedIn" @click="loginUsingOtp('one-step')">Sign In
                                                        <hollow-dots-spinner v-if="signedIn" style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                    </button>
                                                </div>
                                                <!-- <div class="d-flex align-items-center my-3">
                                                    <button type="button" class="btn newcancel text-capitalize" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                    <div class="ml-3">
                                                        <div v-if="!signedIn">
                                                            <button class="btn newsign-in text-capitalize" :disabled="!otp_signin_btn" type="button" @click="loginUsingOtp('one-step')">Sign In</button>
                                                        </div>
                                                        <div v-else class="" style="position: relative;">
                                                            <button class="btn newsign-in text-capitalize" disabled>Signing In</button>
                                                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 28px;display: flex;justify-content: center;width: 160px !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                        </div>
                                                    </div>
                                                </div> -->
                                                <div class="mt-6 forgot-password-button" style="text-align: center;">
                                                    <div v-if="signedIn" style="text-align: center;">
                                                        <p class="fs-14 fw-600  mt-2 pointer default-link" style="color: #fff !important;">Sign in using Password</p>
                                                    </div>
                                                    <div v-else style="text-align: center;">
                                                        <p class="fs-14 mt-2 fw-600 pointer default-link" style="color: #fff !important;" @click="goToPassLogin">Sign in using Password</p>
                                                    </div>
                                                    </div>
                                            </div>
                                        </div>
                                        <div v-if="two_factor_authentication" class="mt-10">
                                            <h1 v-if="login_type == 'email'" class="fs-14 mb-6 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                            <h1 v-if="login_type == 'phone'" class="fs-14 mb-6 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                            <div v-if="two_factor_auth_pass_screen_active">
                                                <p class="text-default-heading mb-5 text-white fw-600">Enter Password<span class="star ml-1">*</span></p>
                                                <div class="d-flex">
                                                    <input v-if="!showPassword" autofocus @keyup.enter="otpInputActive" style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false" type="password"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password" name="password">
                                                    <input v-else type="text" autofocus @keyup.enter="otpInputActive" style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password" name="password">
                                                    <span v-if="!showPassword" style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 20px;">
                                                    </span>
                                                    <span v-else style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 20px;">
                                                    </span>
                                                </div>
                                                <p v-if="password_error_text" class="text-danger mb-5">{{password_error_text}}</p>
                                                <p v-if="signedIn" class="default-link mb-5 text-white" style="color: #fff !important;text-align: end;"><span>Forgot Password ?</span></p>
                                                <p v-else class="default-link mb-5 text-white" @click="forgotPassword" style="color: #fff !important;text-align: end;"><span @click="forgotPassword" class="pointer">Forgot Password ?</span></p>
                                                <!-- <div class="d-flex align-items-center mb-5">
                                                    <button type="button" class="btn btn-new-outline-primary cust-btn-width" @click="cancelTwoFactor" style="min-width: 110px; width: 160px !important;text-transform: none !important;line-height: 20px !important; border-radius: 5px !important;" :disabled="signedIn">Cancel</button>
                                                    <button class="btn btn-new-primary ml-5 cust-btn-width" style="min-width: 110px; width: 160px !important;" type="button" :disabled="signedIn" @click="otpInputActive">Next</button>
                                                </div> -->
                                                <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                    <button class="btn newcancel text-capitalize mr-5" :disabled="signedIn" @click="cancelTwoFactor">Cancel</button>
                                                    <button class="btn newsign-in text-capitalize" :disabled="signedIn || form.password == ''" @click="otpInputActive">Sign In
                                                        <hollow-dots-spinner v-if="signedIn" style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                    </button>
                                                </div>
                                                <!-- <div class="d-flex align-items-center mb-5" v-if="!signedIn">
                                                    <button type="button" class="btn newcancel text-capitalize" @click="cancelTwoFactor">Cancel</button>
                                                    <button class="btn newsign-in ml-5 text-capitalize" type="button" :disabled="signedIn || form.password == ''" @click="otpInputActive">Sign In</button>
                                                </div>
                                                <div class="d-flex align-items-center mb-5" v-else style="text-align: center;">
                                                    <button type="button" class="btn newcancel text-capitalize" disabled>Cancel</button>
                                                    <div class="" style="position: relative;">
                                                        <button class="btn newsign-in ml-5 text-capitalize" type="button" disabled>Sign In</button>
                                                        <hollow-dots-spinner style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;margin-left: 21px;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                    </div>
                                                </div> -->
                                                <p class="fs-14 mt-6 fw-600 pointer default-link" v-if="!signedIn" style="color: #fff !important;text-align: center;" @click="goToOtpLogin('send', 'two-factor-otp')">Sign in using OTP</p>
                                                <p class="fs-14 mt-6 fw-600 pointer default-link" v-if="signedIn" style="color: #fff !important;text-align: center;">Sign in using OTP</p>
                                            </div>
                                            <div v-if="!two_factor_auth_pass_screen_active">
                                                <span class="text-default-heading text-white pb-6 fs-12 fw-600">Enter 6-Digit OTP Code*</span>
                                                <div class="d-flex align-items-start pt-2">
                                                    <div class="" @keyup.enter="loginUsingOtp('two-step')">
                                                        <v-otp-input
                                                        ref="otpInput"
                                                        :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                        separator=""
                                                        :num-inputs="6"
                                                        :should-auto-focus="true"
                                                        :is-input-num="true"
                                                        @on-complete="otpEntered"
                                                        @on-change="otpChangeDetected"
                                                        />
                                                        <div class="d-flex">
                                                            <div style="width: 190px;" class="pt-2">
                                                                <span class="text-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                            </div>
                                                            <div style="color: #3f3f3f" class="ml-2 mt-2">
                                                                <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                                <br>
                                                                <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                            </div>
                                                            <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                        </div>
                                                    </div>
                                                    <!-- <div>
                                                        <div style="color: #3f3f3f">
                                                            <button class="btn btn-new-primary pl-3 pr-3" style="min-width: 110px; width: 160px !important;" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                            <br>
                                                            <span v-if="countdown > 0"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                        </div>
                                                        <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                    </div> -->
                                                </div>
                                                <div v-if="resend_code_success_text" class="mt-2">
                                                    <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                                </div>
                                                <div v-if="otp_error_text" class="mt-2">
                                                    <span class="text-danger fs-14">{{otp_error_text}}</span>
                                                </div>
                                                <div class="mt-10 forgot-password-button" style="text-align: center;">
                                                    <button class="btn newcancel text-capitalize mr-5" @click="cancelOtpScreen" :disabled="two_step_signed_in_otp">Cancel</button>
                                                    <button class="btn newsign-in text-capitalize" :disabled="two_step_signed_in_otp" @click="loginUsingOtp('two-step')">Sign In
                                                        <hollow-dots-spinner v-if="two_step_signed_in_otp" style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                    </button>
                                                </div>
                                                <!-- <div class="my-6" v-if="!two_step_signed_in_otp">
                                                    <div class="d-flex align-items-center my-3">
                                                        <button type="button" class="btn newcancel text-capitalize" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                        <div class="ml-3">
                                                            <button class="btn newsign-in text-capitalize" :disabled="!otp_signin_btn" type="button" @click="loginUsingOtp('two-step')">Sign In</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="my-6" style="position: relative;">
                                                    <div class="d-flex align-items-center my-3">
                                                        <button type="button" class="btn newcancel text-capitalize" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                        <div class="ml-3">
                                                            <button class="btn newsign-in text-capitalize" disabled>Signing In
                                                                <hollow-dots-spinner style="position: absolute;margin: 0;top: 28px;display: flex;justify-content: center;width: 160px !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div> --> 
                                                <div style="text-align: center;" class="mt-6">
                                                    <p class="fs-14 fw-600 mt-2 pointer default-link" v-if="!otp_signin_btn && password_button" style="color: #fff !important;" @click="goToPassLogin('two-factor-password')">Sign in using Password</p>
                                                    <p class="fs-14 fw-600 mt-2 pointer default-link" v-if="otp_signin_btn && password_button" style="color: #fff !important;">Sign in using Password</p>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div v-if="activediv == 'forgot password'">
                                    <div>
                                        <div style="text-align: center !important;">
                                            <span class="text-white text-center fs-30 fw-800">
                                                Forgot Password
                                            </span>
                                        </div>
                                        <hr style="margin-left: 235px !important;width: 70px !important;margin-top: -6px !important;">
                                        <div style="height: 160px;">
                                            <p class="text-default-heading text-white mb-6 mt-10 fw-600">Email Address<span class="star ml-1">*</span></p>
                                            <input style="max-width:450px;" autocomplete="off" type="text" class="digi-form-full-bordered mb-2" placeholder="Enter Email Address" v-model="form.login_id" @input="goToNext('forgot-pass')">
                                            <div v-if="is_email_phone_valid && form.login_id != ''" class="text-danger fw-600 fs-14" style="text-transform: none !important;">Please enter a valid Email Address</div>
                                            <div v-if="is_email_phone_valid_text_forget_pass" class="text-danger fw-600 fs-14" style="text-transform: none !important;">{{is_email_phone_valid_text_forget_pass}}</div>
                                        </div>
                                        <!-- :disabled="forget_pass_btn_disable" -->
                                        <div class="mt-15 forgot-password-button" style="text-align: center;">
                                            <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel" :disabled="forget_pass_btn_disable">Cancel</button>
                                            <button disabled class="btn newsign-in text-capitalize" @click="goToNext('forgot-pass')">Verify</button>
                                        </div>
                                        <div style="text-align: center;" class="mt-6">
                                            <p class="fs-14 fw-600 mt-2 pointer default-link" style="color: #fff !important;" @click="forgotPasswordCancel">Sign in</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div v-if="activediv == 'otp sent message'" class="middle d-flex pt-5 pb-10 px-20" style="height:100%;">
                                    <div class="middle-left"></div>
                                    <div class="middle-right d-flex flex-column pb-10 pl-20">
                                        <img class="mb-12" style="height: 12em;" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/parrot.svg" alt="parrot">
                                        <p v-if="is_using_mobile" class="text-default-heading text-center mb-10" style="font-size: 18px;">A reset password link <br>has been sent to your Phone Number <span class="text-default-blue">XXXXXX{{form.login_id.slice(-4)}}</span></p>
                                        <p v-if="is_using_email" class="text-default-heading text-center mb-10" style="font-size: 18px;">A reset password link <br>has been sent to your Email Address <span class="text-default-blue">XXXXXX{{form.login_id.split("@")[0].slice(-2)}}@{{form.login_id.split("@")[1]}}</span></p>
                                        <span class="text-center">
                                            <button class="btn btn-new-primary mb-5" @click="activediv = 'verify otp'">OK</button>
                                        </span>
                                    </div>
                                </div> -->
                                <div v-if="activediv == 'verify otp'">
                                    <div>
                                        <div style="text-align: center !important;">
                                            <span class="text-white text-center fs-30 fw-800">
                                                Forgot Password
                                            </span>
                                        </div>
                                        <hr style="margin-left: 235px !important;width: 70px !important;margin-top: -6px !important;">
                                        <h1 v-if="is_using_email" class="fs-14 mb-6 mt-8 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                        <h1 v-if="is_using_mobile" class="fs-14 mb-6 mt-8 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                        <div>
                                            <span class="text-default-heading fw-600 mr-10 fs-12 text-white pb-4">A 6-Digit code has been sent to your Mobile</span>
                                            <div class="d-flex align-items-start">
                                                <div class="" @keyup.enter="verifyOtpForgotPass">
                                                    <v-otp-input
                                                    ref="otpInput"
                                                    :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                    separator=""
                                                    :num-inputs="6"
                                                    :should-auto-focus="true"
                                                    :is-input-num="true"
                                                    @on-complete="otpEntered"
                                                    @on-change="otpEntered"
                                                    />
                                                    <div class="d-flex">
                                                        <div style="width: 190px;" class="pt-2">
                                                            <span style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                        </div>
                                                        <div style="color: #3f3f3f" class="ml-2 mt-2">
                                                            <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="getOtpForgetPass('resend')">Resend code</button>
                                                            <br>
                                                            <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                        </div>
                                                        <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                    </div>
                                                    <!-- <div class="">
                                                        <span style="color: #f5a623;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                    </div> -->
                                                </div>
                                                <!-- <div>
                                                    <div style="color: #3f3f3f">
                                                        <button class="btn btn-new-primary pl-3 pr-3" type="button" style="min-width: 110px; width: 160px !important;" :disabled="!countdown == 0" @click="getOtpForgetPass('resend')">Resend code</button>
                                                        <br>
                                                        <span v-if="countdown > 0"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                    </div>
                                                    <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                </div> -->
                                            </div>
                                            <div v-if="resend_code_success_text" class="mt-2">
                                                <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                            </div>
                                            <div v-if="otpInvalid" class="mt-2">
                                                <span class="text-danger fs-14">{{otp_error_text}}</span>
                                            </div>
                                            <div class="mt-10 forgot-password-button" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel" :disabled="forgot_pass_otp_success">Cancel</button>
                                                <button :disabled="forgot_pass_otp_success" class="btn newsign-in text-capitalize" @click="verifyOtpForgotPass">Verify</button>
                                            </div>
                                            <!-- <div style="text-align: center !important;">
                                                <div class="d-flex align-items-center mb-2 mt-10 mb-5">
                                                    <div>
                                                        <button class="btn newcancel text-capitalize" @click="forgotPasswordCancel">Cancel</button>
                                                    </div>
                                                    <div class="ml-4" v-if="!forgot_pass_otp_success">
                                                        <button class="btn newsign-in text-capitalize" type="button" @click="verifyOtpForgotPass">Verify</button>
                                                    </div>
                                                    <div v-else class="ml-4" style="position: relative;">
                                                        <button class="btn newsign-in text-capitalize" disabled>Verifying</button>
                                                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 28px;display: flex;justify-content: center;width: 160px !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div style="text-align: center;" class="mt-6">
                                                <p class="fs-14 fw-600 mt-2 pointer default-link" style="color: #fff !important;" @click="forgotPasswordCancel">Sign in</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="activediv == 'set new password'" style="height:100%;">
                                    <div>
                                        <div style="text-align: center !important;">
                                            <span class="text-white text-center fs-30 fw-800">
                                                Reset Password
                                            </span>
                                        </div>
                                        <hr style="margin-left: 228px !important;width: 70px !important;margin-top: -6px !important;">
                                        <h1 v-if="is_using_email" class="fs-14 mb-4 mt-4 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                        <h1 v-if="is_using_mobile" class="fs-14 mb-4 mt-4 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <span class="text-default-heading text-white fw-600">New Password<span class="star ml-1">*</span></span>
                                                <div class="d-flex aligm-items-center mt-5 position-relative" style="max-width: 450px;">
                                                    <input  autocomplete="off" style="padding-right: 40px !important;" v-if="!showNewPassword" oncopy="return false" onpaste="return false" oncut="return false" type="password" @input="onPassInput" class="digi-form-full-bordered" placeholder="Enter Password" v-model="form.password" name="new_password" v-validate="{min:8,regex:/^(?=.{8,})(?=.*[0-9])(?=.*[A-Z])(?=.*[@#$%^&+=()!*]).*$/}">
                                                    <input  autocomplete="off" style="padding-right: 40px !important;" v-else type="text" oncopy="return false" onpaste="return false" oncut="return false" class="digi-form-full-bordered" @input="onPassInput" placeholder="Enter Password" v-model="form.password" name="new_password" v-validate="{min:8,regex:/^(?=.{8,})(?=.*[0-9])(?=.*[A-Z])(?=.*[@#$%^&+=()!*]).*$/}">
                                                    <span @click="showNewPassword = !showNewPassword" style="width: 18px;position: absolute;right: 35px;bottom: 9px">
                                                        <img v-if="!showNewPassword" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 18px;">
                                                        <img v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 18px;">
                                                    </span>
                                                    <password-meter :pwd="form.password" id="password" style="display:none"></password-meter>
                                                    <!-- <span class="invalid-feedback-form text-danger mb-5 mt-0" v-show="errors.has('new_password')">{{ errors.first("new_password") }}</span> -->
                                                    <span class="ml-2 mt-2">
                                                        <el-tooltip effect="light" placement="left">
                                                            <div slot="content" style="color: #3f3f3f; font-size: 12px;">
                                                                <span style="font-weight: 600;">Password must contain the following</span>
                                                                <br>
                                                                <span style="width:200px">
                                                                    <span>
                                                                        <i v-if="is_uppercase_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                        <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                        At-least one uppercase letter (ex: A to Z)
                                                                    </span><br>
                                                                    <span>
                                                                        <i v-if="is_number_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                        <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                        At-least one digit (ex: 0 to 9)
                                                                    </span><br>
                                                                    <span>
                                                                        <i v-if="is_special_character_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                        <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                        At-least one special character (ex: $,#,@,!,%,^,&,*,(,),)<br>
                                                                    </span>
                                                                    <span>
                                                                        <i v-if="min_pwd_length" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                        <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                        Minimum 8 characters
                                                                    </span><br>
                                                                </span>
                                                            </div>
                                                            <!-- <i class="icon-information text-default-blue fs-18"></i> -->
                                                        </el-tooltip>
                                                    </span>
                                                </div>
                                                <span class="invalid-feedback-form text-danger mb-5 position-absolute" style="margin-top: 4px !important;" v-show="errors.has('new_password')">Please Enter New Password</span>
                                            </div>
                                        </div>
                                        <div class="row mt-7">
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <span class="text-default-heading text-white fw-600 mt-5">Confirm Password<span class="star ml-1">*</span></span>
                                                <div class="d-flex aligm-items-center mt-5 position-relative" style="max-width: 450px;">
                                                    <input v-if="!showConfirmNewPassword" style="padding-right: 40px !important;margin-right:10px;" oncopy="return false" onpaste="return false" oncut="return false" type="password" name="confirmpassword" class="digi-form-full-bordered" placeholder="Enter Password" v-model="confirmPassword" v-validate="'required'">
                                                    <input v-else type="text" style="padding-right: 40px !important;margin-right:10px;" oncopy="return false" onpaste="return false" oncut="return false" class="digi-form-full-bordered" name="confirmpassword" placeholder="Enter Password" v-model="confirmPassword" v-validate="'required'">
                                                    <span @click="showConfirmNewPassword = !showConfirmNewPassword" style="width: 18px;position: absolute;right: 35px;bottom: 9px">
                                                        <img v-if="!showConfirmNewPassword" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 18px;">
                                                        <img v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 18px;">
                                                    </span>
                                                </div>
                                                <!-- <p v-if="form.password != confirmPassword && confirmPassword" class="text-danger">Passwords does not match</p> -->
                                                <p v-if="errorMessage" class="text-danger">{{errorMessage}}</p>
                                                <!-- <span class="invalid-feedback-form text-danger mb-5" style="margin-top: 4px !important;" v-show="errors.has('confirmpassword')">Please Enter Password</span> -->
                                            </div>
                                        </div>
                                        <div class="mt-10 forgot-password-button" style="text-align: center;">
                                            <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel">Cancel</button>
                                            <button class="btn newsign-in text-capitalize" @click="resetPassword">Confirm</button>
                                        </div>
                                        <!-- <span class="mt-7" style="text-align: center;">
                                            <button class="btn newcancel text-capitalize mr-4 mt-6" @click="forgotPasswordCancel">Cancel</button>
                                            <button class="btn newsign-in text-capitalize mt-6" @click="resetPassword">Confirm</button>
                                        </span> -->
                                    </div>
                                </div>
                                <div v-if="activediv == 'reset successfull'" class="middle d-flex pt-5 pb-10 px-20 w-100" style="height:100%;">
                                    <div class="middle-left"></div>
                                    <div class="middle-right d-flex flex-column pb-10 pl-10">
                                        <img class="mb-12" style="height: 12em;" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/parrot.svg" alt="parrot">
                                        <p class="text-default-heading text-center mb-5" style="font-size: 30px; font-weight: 700;">Success</p>
                                        <p v-if="is_using_mobile" class="text-default-heading text-center mb-10" style="font-size: 18px;">Changed your password Successfully and a confirmation <br>has been sent to your phone number <span class="text-default-blue">{{form.login_id.slice(0,2)}}XXXXXX{{form.login_id.slice(-4)}}</span></p>
                                        <p v-if="is_using_email" class="text-default-heading text-center mb-10" style="font-size: 18px;">Changed your password Successfully and a confirmation <br>has been sent to your Email Address <span class="text-default-blue">{{form.login_id.slice(0,2)}}XXXXXX{{form.login_id.split("@")[0].slice(-2)}}@{{form.login_id.split("@")[1]}}</span></p>
                                        <span class="text-center">
                                            <button class="btn btn-new-primary mb-5" style="min-width: 110px; width: 160px !important;" :disabled="resend_btn_disable" @click="resetSuccessfull">OK</button>
                                        </span>
                                    </div>
                                </div>
                                <!-- <span class="mt-7">
                                    <button class="btn cancel mb-5">Cancel</button>
                                    <button class="btn sign-in mb-5 ml-4">Submit</button>
                                </span> -->
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cr-backimg">
            <div class="d-flex flex-column" style="width: 98%;min-height:95%; height:100%;">
                <div class="top pb-4">
                    <span><span style="" class="p-1"><img src="/static/images/Digicollect_Logo.svg" alt="DigiHelp" class="digiadmin-logo" style="width: 40px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> </span></span>
                    <span class="text-default-blue crm-right-logo" style="font-size: 26px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;padding-right: 30px;">
                        <span style="" class="px-1 mr-1"><img src="/static/images/help_whitelogo.svg" alt="DigiHelp" class="digiadmin-logo" style="width: 40px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> </span>
                        DigiHelp
                    </span>
                </div>
                <div class="d-flex newflex-reverse top">
                    <div style="width: 100%;">
                        <div>
                            <span class="fs-30 fw-800" style="color: #fff;">Streamlining Success!</span>
                        </div>
                        <hr class="mt-5">
                        <div v-if="activediv == 'forgot password'">
                            <div class="mt-4 px-8">
                                <img src="/static/images/forgot-password.svg" alt="" width="75%">
                            </div>
                            <div class="mt-8">
                                <span class="fs-14" style="color: #fff;">
                                    No worries! Set your new password following these simple steps.
                                </span>
                            </div>
                        </div>
                        <div v-else-if="activediv == 'verify otp'">
                            <div class="mt-4 px-8">
                                <img src="/static/images/forgot-password.svg" alt="" width="75%">
                            </div>
                            <div class="mt-8">
                                <span class="fs-14" style="color: #fff;">
                                    No worries! Set your new password following these simple steps.
                                </span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="mt-4 px-8">
                                <img src="/static/images/newlogin.svg" alt="" width="100%">
                            </div>
                            <div class="mt-8">
                                <span class="fs-14" style="color: #fff;">
                                    An integrated ticketing system that manages workflow and 
                                    communication with customers and users. Helps in tracking
                                    tickets and their progress in the real time
                                </span>
                            </div>
                        </div>
                    </div>
                    <div style="width: 25%;"></div>
                    <div style="width: 100%;">
                        <div class="right-box">
                            <div v-if="activediv == 'login'">
                                <div style="text-align: center !important;">
                                    <span class="text-white text-center fs-30 fw-800">
                                        Sign 
                                    </span>
                                    <span class="text-white text-center fs-30 fw-800" style="border-bottom: 4px solid #fff;">In</span>
                                </div>
                                <!-- <hr style="margin-left: 203px !important;width: 24px !important;margin-top: -6px !important;"> -->
                                <div v-if="enter_email_screen">
                                    <!--p class="text-grey-default mb-10">Need an Account? <span class="font-weight-bold" style="cursor: pointer; color: #005dae !important;" @click="registerUser">Click here</span> to Sign up</p-->
                                    <!-- <p class="text-default-heading mb-2">Account Type</p>
                                    <div class="d-flex mb-5">
                                        <div class="form-check form-check-inline">
                                            <label class="form-check-label check-label-dc mr-2">
                                                <input
                                                class="form-check-input"
                                                type="radio"
                                                name="accountType"
                                                v-validate="'required'"
                                                value="Personal"
                                                v-model="account_type"
                                                />
                                                <span class="radio-icon"></span>
                                                <span
                                                class="d-flex fw-600 pt-1"
                                                style="font-size: 12px !important;color: #3f3f3f;"
                                                >Personal</span>
                                            </label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <label class="form-check-label check-label-dc">
                                                <input
                                                    class="form-check-input"
                                                    type="radio"
                                                    name="accountType"
                                                    v-validate="'required'"
                                                    value="Business"
                                                    v-model="account_type"
                                                />
                                                <span class="radio-icon"></span>
                                                <span
                                                    class="d-flex fw-600 pt-1"
                                                    style="font-size: 12px !important;color: #3f3f3f;"
                                                >Business</span>
                                            </label>
                                        </div>
                                    </div> -->
                                </div>
                                <form action="javascript:;">
                                    <div v-if="enter_email_screen" class="mt-6">
                                        <div style="height: 180px;">
                                            <p class="text-default-heading mb-3 text-white fw-600">Email Address<span class="star ml-1">*</span></p>
                                            <div class="w-100" v-if="oldlogin_id">
                                                <div class="d-flex justify-content-end align-items-center">
                                                    <input type="text" autocomplete="off" @keyup.enter="goToNext('login')" class="digi-form-full-bordered mb-2" autofocus name="userid" placeholder="Enter Email Address" @input="goToNext('login')" v-model="form.login_id">
                                                    <!-- <div>
                                                        <img src="/static/images/check-fill.svg" width="20px" style="margin-left: -35px;margin-bottom: 6px">
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="w-100" v-if="login_id_true">
                                                <div class="d-flex justify-content-end align-items-center">
                                                    <input type="text" autocomplete="off" @keyup.enter="goToNext('login')" class="digi-form-full-bordered mb-2" autofocus name="userid" placeholder="Enter Email Address" @input="checkUserIdback" v-model="form.login_id">
                                                    <div>
                                                        <img src="/static/images/check-fill.svg" width="20px" style="margin-left: -35px;margin-bottom: 6px">
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- v-show="errors.has('userid')"  -->
                                            <span class="text-danger fw-600 fs-14 mb-5" style="text-transform: none !important;" v-if="is_email_valid_text && form.login_id != ''">Please enter a valid Email Address</span>
                                            <span v-if="is_email_phone_valid" class="text-danger fw-600 fs-14 mb-5" style="text-transform: none !important;">{{is_email_phone_valid_text}}</span>
                                        </div>
                                        <!-- <div > -->
                                            <div v-if="login_id_true" class="forgot-password-button mt-8" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize fs-14 mr-5" type="button" @click="checkUserIdEmpty">Cancel</button>
                                                <!-- v-if="!login_btn_disable" <button class="btn newcancel text-capitalize fs-14 mr-5" type="button">Cancel</button> -->
                                                <button class="btn newsign-in text-capitalize fs-14" :disabled="login_id_true" type="button" @click="goToNext('login')">Sign In</button>
                                            </div>
                                        <!-- </div> -->
                                        <div v-else class="mt-8 d-flex justify-content-end">
                                            <!-- <button v-if="login_id_true" class="btn newcancel text-capitalize fs-14 mr-3" type="button" @click="checkUserIdEmpty">Cancel</button> -->
                                            <!-- v-if="!login_btn_disable" <button class="btn newcancel text-capitalize fs-14 mr-5" type="button">Cancel</button> -->
                                            <button class="btn newsign-in text-capitalize fs-14" :disabled="!login_id_true" type="button" @click="goToNext('login')">Sign In</button>
                                        </div>
                                        <!-- <div v-else class="mt-8 d-flex justify-content-end" style="position: relative;float:right;">
                                            <button class="btn newsign-in" disabled>Checking</button>
                                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 28px;width: 160px !important;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                        </div> -->
                                    </div>
                                    <div v-if="user_not_verified" class="mt-6">
                                        <h1 v-if="login_type == 'email'" class="fs-14 mb-6 font-weight-bold text-white"><span class="text-white"><img src="/static/images/author-img.svg" alt="" width="34px">{{form.login_id}}</span></h1>
                                        <h1 v-if="login_type == 'phone'" class="fs-14 mb-6 font-weight-bold text-white"><span class="text-white"><img src="/static/images/author-img.svg" alt="" width="34px">{{form.login_id}}</span></h1>
                                        <div class="text-center" style="max-width: 380px">
                                            <div class="mb-2 ml-auto mr-auto" style="max-width: 230px">
                                                <img style="width: 100%;" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/duck.svg" alt="Duck" />
                                            </div>
                                            <p class="text-white mb-2" style="font-size: 20px; font-weight: 800;">Verification Pending!!</p>
                                            <p class="text-white mb-2" style="font-size: 14px;">Your Verification link has been expired, Resend Link to verify</p>
                                            <div class="mt-4">
                                                <div class="forgot-password-button" style="text-align: center;">
                                                    <button class="btn newcancel text-capitalize mb-5 mr-5" :disabled="resend_btn_disable" @click="cancelResendLink">Cancel</button>
                                                    <button class="btn newsign-in mb-5 text-capitalize" :disabled="resend_btn_disable" style="min-width: 110px; width: 160px !important;" @click="resendUserVerifyLink">Resend Link 
                                                        <hollow-dots-spinner v-if="resend_btn_disable" style="position: absolute;margin: 0;top: 25px;width: 160px !important;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                    </button>
                                                </div>
                                                <div v-if="resend_verification_link_success" class="text-default-blue fs-14 mt-2">{{resend_verification_link_success}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="enter_pass_screen" class="mt-6">
                                        <h1 v-if="login_type == 'email'" class="fs-14 mb-6 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                        <h1 v-if="login_type == 'phone'" class="fs-14 mb-6 font-weight-bold text-white"><img src="/static/images/author-img.svg" alt="" width="34px"> <span class="text-white">{{form.login_id}}</span></h1>
                                        <div v-if="!sign_in_using_otp">
                                            <p class="text-default-heading mb-5 text-white fw-600">Enter Password<span class="star ml-1">*</span></p>
                                            <div class="d-flex">
                                                <input v-if="!showPassword" style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false" type="password"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password" name="password">
                                                <input v-else type="text" style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password" name="password">
                                                <span v-if="!showPassword" style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 20px;">
                                                </span>
                                                <span v-else style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 20px;">
                                                </span>
                                            </div>
                                            <p v-if="password_error_text" class="text-danger mb-5">{{password_error_text}}</p>
                                            <p class="default-link mb-5 text-white" style="color: #fff !important;text-align: end;"><span @click="forgotPassword" class="pointer">Forgot Password ?</span></p>
                                            <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize mr-5" :disabled="signedIn" @click="cancelPassScreen">Cancel</button>
                                                <button :disabled="signedIn || form.password == ''" class="btn newsign-in text-capitalize" @click="loginUsingPassword('one-step')">Sign In
                                                    <hollow-dots-spinner v-if="signedIn" style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                </button>
                                            </div>
                                            <div v-if="signedIn" style="text-align: center;" class="mt-6">
                                                <p class="fs-14 mt-0 fw-600 pointer default-link" style="color: #fff !important;">Sign in using OTP</p>
                                            </div>
                                            <div v-else style="text-align: center;" class="mt-6">
                                                <p class="fs-14 mt-0 fw-600 pointer default-link" style="color: #fff !important;" @click="goToOtpLogin('send')" >Sign in using OTP</p>
                                            </div>
                                        </div>
                                        <div v-if="sign_in_using_otp">
                                            <span class="text-default-heading text-white pb-6 fs-12 fw-600">Enter 6-Digit OTP Code*</span>
                                            <div>
                                                <div class="d-flex align-items-start mt-2">
                                                    <div class="" @keyup.enter="loginUsingOtp('one-step')">
                                                        <v-otp-input
                                                        ref="otpInput"
                                                        :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                        separator=""
                                                        :num-inputs="6"
                                                        :should-auto-focus="true"
                                                        :is-input-num="true"
                                                        @on-complete="otpEntered"
                                                        @on-change="otpChangeDetected"
                                                        />
                                                        <div class="d-flex">
                                                            <div style="width: 190px;" class="pt-2">
                                                                <span class="text-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                            </div>
                                                            <div style="color: #3f3f3f" class="ml-2 mt-2">
                                                                <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                                <br>
                                                                <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                            </div>
                                                            <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                        </div>
                                                        <!-- <div class="mt-2">
                                                            <span style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                            <div style="color: #fff" class="mt-2">
                                                                <button class="btn resend-code text-capitalize" style="min-width: 110px; width: 160px !important;" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                                <br>
                                                                <span v-if="countdown > 0"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                            </div>
                                                            <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                        </div> -->
                                                    </div>
                                                    <!-- <div>
                                                        <div style="color: #3f3f3f">
                                                            <button class="btn btn-new-primary pl-3 pr-3" style="min-width: 110px; width: 160px !important;" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                            <br>
                                                            <span v-if="countdown > 0"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                        </div>
                                                        <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                    </div> -->
                                                </div>
                                                <div v-if="resend_code_success_text" class="mt-2">
                                                    <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                                </div>
                                                <div v-if="otp_error_text" class="mt-2">
                                                    <span class="text-danger fs-14">{{otp_error_text}}</span>
                                                </div>
                                            </div>
                                            <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize mr-5" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                <button class="btn newsign-in text-capitalize" :disabled="signedIn" @click="loginUsingOtp('one-step')">Sign In
                                                    <hollow-dots-spinner v-if="signedIn" style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                </button>
                                            </div>
                                            <!-- <div class="d-flex align-items-center my-3">
                                                <button type="button" class="btn newcancel text-capitalize" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                <div class="ml-3">
                                                    <div v-if="!signedIn">
                                                        <button class="btn newsign-in text-capitalize" :disabled="!otp_signin_btn" type="button" @click="loginUsingOtp('one-step')">Sign In</button>
                                                    </div>
                                                    <div v-else class="" style="position: relative;">
                                                        <button class="btn newsign-in text-capitalize" disabled>Signing In</button>
                                                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 28px;display: flex;justify-content: center;width: 160px !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="mt-6 forgot-password-button" style="text-align: center;">
                                                <div v-if="signedIn" style="text-align: center;">
                                                    <p class="fs-14 fw-600  mt-2 pointer default-link" style="color: #fff !important;">Sign in using Password</p>
                                                </div>
                                                <div v-else style="text-align: center;">
                                                    <p class="fs-14 mt-2 fw-600 pointer default-link" style="color: #fff !important;" @click="goToPassLogin">Sign in using Password</p>
                                                </div>
                                                </div>
                                        </div>
                                    </div>
                                    <div v-if="two_factor_authentication" class="mt-10">
                                        <h1 v-if="login_type == 'email'" class="fs-14 mb-6 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                        <h1 v-if="login_type == 'phone'" class="fs-14 mb-6 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                        <div v-if="two_factor_auth_pass_screen_active">
                                            <p class="text-default-heading mb-5 text-white fw-600">Enter Password<span class="star ml-1">*</span></p>
                                            <div class="d-flex">
                                                <input v-if="!showPassword" autofocus @keyup.enter="otpInputActive" style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false" type="password"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password" name="password">
                                                <input v-else type="text" autofocus @keyup.enter="otpInputActive" style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password" name="password">
                                                <span v-if="!showPassword" style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 20px;">
                                                </span>
                                                <span v-else style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 20px;">
                                                </span>
                                            </div>
                                            <p v-if="password_error_text" class="text-danger mb-5">{{password_error_text}}</p>
                                            <p v-if="signedIn" class="default-link mb-5 text-white" style="color: #fff !important;text-align: end;"><span>Forgot Password ?</span></p>
                                            <p v-else class="default-link mb-5 text-white" @click="forgotPassword" style="color: #fff !important;text-align: end;"><span @click="forgotPassword" class="pointer">Forgot Password ?</span></p>
                                            <!-- <div class="d-flex align-items-center mb-5">
                                                <button type="button" class="btn btn-new-outline-primary cust-btn-width" @click="cancelTwoFactor" style="min-width: 110px; width: 160px !important;text-transform: none !important;line-height: 20px !important; border-radius: 5px !important;" :disabled="signedIn">Cancel</button>
                                                <button class="btn btn-new-primary ml-5 cust-btn-width" style="min-width: 110px; width: 160px !important;" type="button" :disabled="signedIn" @click="otpInputActive">Next</button>
                                            </div> -->
                                            <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize mr-5" :disabled="signedIn" @click="cancelTwoFactor">Cancel</button>
                                                <button class="btn newsign-in text-capitalize" :disabled="signedIn || form.password == ''" @click="otpInputActive">Sign In
                                                    <hollow-dots-spinner v-if="signedIn" style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                </button>
                                            </div>
                                            <!-- <div class="d-flex align-items-center mb-5" v-if="!signedIn">
                                                <button type="button" class="btn newcancel text-capitalize" @click="cancelTwoFactor">Cancel</button>
                                                <button class="btn newsign-in ml-5 text-capitalize" type="button" :disabled="signedIn || form.password == ''" @click="otpInputActive">Sign In</button>
                                            </div>
                                            <div class="d-flex align-items-center mb-5" v-else style="text-align: center;">
                                                <button type="button" class="btn newcancel text-capitalize" disabled>Cancel</button>
                                                <div class="" style="position: relative;">
                                                    <button class="btn newsign-in ml-5 text-capitalize" type="button" disabled>Sign In</button>
                                                    <hollow-dots-spinner style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;margin-left: 21px;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                </div>
                                            </div> -->
                                            <p class="fs-14 mt-6 fw-600 pointer default-link" v-if="!signedIn" style="color: #fff !important;text-align: center;" @click="goToOtpLogin('send', 'two-factor-otp')">Sign in using OTP</p>
                                            <p class="fs-14 mt-6 fw-600 pointer default-link" v-if="signedIn" style="color: #fff !important;text-align: center;">Sign in using OTP</p>
                                        </div>
                                        <div v-if="!two_factor_auth_pass_screen_active">
                                            <span class="text-default-heading text-white pb-6 fs-12 fw-600">Enter 6-Digit OTP Code*</span>
                                            <div class="d-flex align-items-start pt-2">
                                                <div class="" @keyup.enter="loginUsingOtp('two-step')">
                                                    <v-otp-input
                                                    ref="otpInput"
                                                    :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                    separator=""
                                                    :num-inputs="6"
                                                    :should-auto-focus="true"
                                                    :is-input-num="true"
                                                    @on-complete="otpEntered"
                                                    @on-change="otpChangeDetected"
                                                    />
                                                    <div class="d-flex">
                                                        <div style="width: 190px;" class="pt-2">
                                                            <span class="text-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                        </div>
                                                        <div style="color: #3f3f3f" class="ml-2 mt-2">
                                                            <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                            <br>
                                                            <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                        </div>
                                                        <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                    </div>
                                                </div>
                                                <!-- <div>
                                                    <div style="color: #3f3f3f">
                                                        <button class="btn btn-new-primary pl-3 pr-3" style="min-width: 110px; width: 160px !important;" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')">Resend code</button>
                                                        <br>
                                                        <span v-if="countdown > 0"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                    </div>
                                                    <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                </div> -->
                                            </div>
                                            <div v-if="resend_code_success_text" class="mt-2">
                                                <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                            </div>
                                            <div v-if="otp_error_text" class="mt-2">
                                                <span class="text-danger fs-14">{{otp_error_text}}</span>
                                            </div>
                                            <div class="mt-10 forgot-password-button" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize mr-5" @click="cancelOtpScreen" :disabled="two_step_signed_in_otp">Cancel</button>
                                                <button class="btn newsign-in text-capitalize" :disabled="two_step_signed_in_otp" @click="loginUsingOtp('two-step')">Sign In
                                                    <hollow-dots-spinner v-if="two_step_signed_in_otp" style="position: absolute;width: 160px !important;margin: 0;top: 28px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                </button>
                                            </div>
                                            <!-- <div class="my-6" v-if="!two_step_signed_in_otp">
                                                <div class="d-flex align-items-center my-3">
                                                    <button type="button" class="btn newcancel text-capitalize" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                    <div class="ml-3">
                                                        <button class="btn newsign-in text-capitalize" :disabled="!otp_signin_btn" type="button" @click="loginUsingOtp('two-step')">Sign In</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="my-6" style="position: relative;">
                                                <div class="d-flex align-items-center my-3">
                                                    <button type="button" class="btn newcancel text-capitalize" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                    <div class="ml-3">
                                                        <button class="btn newsign-in text-capitalize" disabled>Signing In
                                                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 28px;display: flex;justify-content: center;width: 160px !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div> --> 
                                            <div style="text-align: center;" class="mt-6">
                                                <p class="fs-14 fw-600 mt-2 pointer default-link" v-if="!otp_signin_btn && password_button" style="color: #fff !important;" @click="goToPassLogin('two-factor-password')">Sign in using Password</p>
                                                <p class="fs-14 fw-600 mt-2 pointer default-link" v-if="otp_signin_btn && password_button" style="color: #fff !important;">Sign in using Password</p>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div v-if="activediv == 'forgot password'">
                                <div>
                                    <div style="text-align: center !important;">
                                        <span class="text-white text-center fs-30 fw-800">
                                            Forgot Password
                                        </span>
                                    </div>
                                    <hr style="margin-left: 235px !important;width: 70px !important;margin-top: -6px !important;">
                                    <div style="height: 160px;">
                                        <p class="text-default-heading text-white mb-6 mt-10 fw-600">Email Address<span class="star ml-1">*</span></p>
                                        <input style="max-width:450px;" autocomplete="off" type="text" class="digi-form-full-bordered mb-2" placeholder="Enter Email Address" v-model="form.login_id" @input="goToNext('forgot-pass')">
                                        <div v-if="is_email_phone_valid && form.login_id != ''" class="text-danger fw-600 fs-14" style="text-transform: none !important;">Please enter a valid Email Address</div>
                                        <div v-if="is_email_phone_valid_text_forget_pass" class="text-danger fw-600 fs-14" style="text-transform: none !important;">{{is_email_phone_valid_text_forget_pass}}</div>
                                    </div>
                                    <!-- :disabled="forget_pass_btn_disable" -->
                                    <div class="mt-15 forgot-password-button" style="text-align: center;">
                                        <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel" :disabled="forget_pass_btn_disable">Cancel</button>
                                        <button disabled class="btn newsign-in text-capitalize" @click="goToNext('forgot-pass')">Verify</button>
                                    </div>
                                    <div style="text-align: center;" class="mt-6">
                                        <p class="fs-14 fw-600 mt-2 pointer default-link" style="color: #fff !important;" @click="forgotPasswordCancel">Sign in</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div v-if="activediv == 'otp sent message'" class="middle d-flex pt-5 pb-10 px-20" style="height:100%;">
                                <div class="middle-left"></div>
                                <div class="middle-right d-flex flex-column pb-10 pl-20">
                                    <img class="mb-12" style="height: 12em;" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/parrot.svg" alt="parrot">
                                    <p v-if="is_using_mobile" class="text-default-heading text-center mb-10" style="font-size: 18px;">A reset password link <br>has been sent to your Phone Number <span class="text-default-blue">XXXXXX{{form.login_id.slice(-4)}}</span></p>
                                    <p v-if="is_using_email" class="text-default-heading text-center mb-10" style="font-size: 18px;">A reset password link <br>has been sent to your Email Address <span class="text-default-blue">XXXXXX{{form.login_id.split("@")[0].slice(-2)}}@{{form.login_id.split("@")[1]}}</span></p>
                                    <span class="text-center">
                                        <button class="btn btn-new-primary mb-5" @click="activediv = 'verify otp'">OK</button>
                                    </span>
                                </div>
                            </div> -->
                            <div v-if="activediv == 'verify otp'">
                                <div>
                                    <div style="text-align: center !important;">
                                        <span class="text-white text-center fs-30 fw-800">
                                            Forgot Password
                                        </span>
                                    </div>
                                    <hr style="margin-left: 235px !important;width: 70px !important;margin-top: -6px !important;">
                                    <h1 v-if="is_using_email" class="fs-14 mb-6 mt-8 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                    <h1 v-if="is_using_mobile" class="fs-14 mb-6 mt-8 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                    <div>
                                        <span class="text-default-heading fw-600 mr-10 fs-12 text-white pb-4">A 6-Digit code has been sent to your Mobile</span>
                                        <div class="d-flex align-items-start">
                                            <div class="" @keyup.enter="verifyOtpForgotPass">
                                                <v-otp-input
                                                ref="otpInput"
                                                :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                separator=""
                                                :num-inputs="6"
                                                :should-auto-focus="true"
                                                :is-input-num="true"
                                                @on-complete="otpEntered"
                                                @on-change="otpEntered"
                                                />
                                                <div class="d-flex">
                                                    <div style="width: 190px;" class="pt-2">
                                                        <span style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                    </div>
                                                    <div style="color: #3f3f3f" class="ml-2 mt-2">
                                                        <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="getOtpForgetPass('resend')">Resend code</button>
                                                        <br>
                                                        <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                    </div>
                                                    <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                </div>
                                                <!-- <div class="">
                                                    <span style="color: #f5a623;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                </div> -->
                                            </div>
                                            <!-- <div>
                                                <div style="color: #3f3f3f">
                                                    <button class="btn btn-new-primary pl-3 pr-3" type="button" style="min-width: 110px; width: 160px !important;" :disabled="!countdown == 0" @click="getOtpForgetPass('resend')">Resend code</button>
                                                    <br>
                                                    <span v-if="countdown > 0"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                </div>
                                                <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                            </div> -->
                                        </div>
                                        <div v-if="resend_code_success_text" class="mt-2">
                                            <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                        </div>
                                        <div v-if="otpInvalid" class="mt-2">
                                            <span class="text-danger fs-14">{{otp_error_text}}</span>
                                        </div>
                                        <div class="mt-10 forgot-password-button" style="text-align: center;">
                                            <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel" :disabled="forgot_pass_otp_success">Cancel</button>
                                            <button :disabled="forgot_pass_otp_success" class="btn newsign-in text-capitalize" @click="verifyOtpForgotPass">Verify</button>
                                        </div>
                                        <!-- <div style="text-align: center !important;">
                                            <div class="d-flex align-items-center mb-2 mt-10 mb-5">
                                                <div>
                                                    <button class="btn newcancel text-capitalize" @click="forgotPasswordCancel">Cancel</button>
                                                </div>
                                                <div class="ml-4" v-if="!forgot_pass_otp_success">
                                                    <button class="btn newsign-in text-capitalize" type="button" @click="verifyOtpForgotPass">Verify</button>
                                                </div>
                                                <div v-else class="ml-4" style="position: relative;">
                                                    <button class="btn newsign-in text-capitalize" disabled>Verifying</button>
                                                    <hollow-dots-spinner style="position: absolute;margin: 0;top: 28px;display: flex;justify-content: center;width: 160px !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                </div>
                                            </div>
                                        </div> -->
                                        <div style="text-align: center;" class="mt-6">
                                            <p class="fs-14 fw-600 mt-2 pointer default-link" style="color: #fff !important;" @click="forgotPasswordCancel">Sign in</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="activediv == 'set new password'" style="height:100%;">
                                <div>
                                    <div style="text-align: center !important;">
                                        <span class="text-white text-center fs-30 fw-800">
                                            Reset Password
                                        </span>
                                    </div>
                                    <hr style="margin-left: 228px !important;width: 70px !important;margin-top: -6px !important;">
                                    <h1 v-if="is_using_email" class="fs-14 mb-4 mt-4 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                    <h1 v-if="is_using_mobile" class="fs-14 mb-4 mt-4 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <span class="text-default-heading text-white fw-600">New Password<span class="star ml-1">*</span></span>
                                            <div class="d-flex aligm-items-center mt-5 position-relative" style="max-width: 450px;">
                                                <input  autocomplete="off" style="padding-right: 40px !important;" v-if="!showNewPassword" oncopy="return false" onpaste="return false" oncut="return false" type="password" @input="onPassInput" class="digi-form-full-bordered" placeholder="Enter Password" v-model="form.password" name="new_password" v-validate="{min:8,regex:/^(?=.{8,})(?=.*[0-9])(?=.*[A-Z])(?=.*[@#$%^&+=()!*]).*$/}">
                                                <input  autocomplete="off" style="padding-right: 40px !important;" v-else type="text" oncopy="return false" onpaste="return false" oncut="return false" class="digi-form-full-bordered" @input="onPassInput" placeholder="Enter Password" v-model="form.password" name="new_password" v-validate="{min:8,regex:/^(?=.{8,})(?=.*[0-9])(?=.*[A-Z])(?=.*[@#$%^&+=()!*]).*$/}">
                                                <span @click="showNewPassword = !showNewPassword" style="width: 18px;position: absolute;right: 35px;bottom: 9px">
                                                    <img v-if="!showNewPassword" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 18px;">
                                                    <img v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 18px;">
                                                </span>
                                                <password-meter :pwd="form.password" id="password" style="display:none"></password-meter>
                                                <!-- <span class="invalid-feedback-form text-danger mb-5 mt-0" v-show="errors.has('new_password')">{{ errors.first("new_password") }}</span> -->
                                                <span class="ml-2 mt-2">
                                                    <el-tooltip effect="light" placement="left">
                                                        <div slot="content" style="color: #3f3f3f; font-size: 12px;">
                                                            <span style="font-weight: 600;">Password must contain the following</span>
                                                            <br>
                                                            <span style="width:200px">
                                                                <span>
                                                                    <i v-if="is_uppercase_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                    <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                    At-least one uppercase letter (ex: A to Z)
                                                                </span><br>
                                                                <span>
                                                                    <i v-if="is_number_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                    <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                    At-least one digit (ex: 0 to 9)
                                                                </span><br>
                                                                <span>
                                                                    <i v-if="is_special_character_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                    <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                    At-least one special character (ex: $,#,@,!,%,^,&,*,(,),)<br>
                                                                </span>
                                                                <span>
                                                                    <i v-if="min_pwd_length" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                    <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                    Minimum 8 characters
                                                                </span><br>
                                                            </span>
                                                        </div>
                                                        <!-- <i class="icon-information text-default-blue fs-18"></i> -->
                                                    </el-tooltip>
                                                </span>
                                            </div>
                                            <span class="invalid-feedback-form text-danger mb-5 position-absolute" style="margin-top: 4px !important;" v-show="errors.has('new_password')">Please Enter New Password</span>
                                        </div>
                                    </div>
                                    <div class="row mt-7">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <span class="text-default-heading text-white fw-600 mt-5">Confirm Password<span class="star ml-1">*</span></span>
                                            <div class="d-flex aligm-items-center mt-5 position-relative" style="max-width: 450px;">
                                                <input v-if="!showConfirmNewPassword" style="padding-right: 40px !important;margin-right:10px;" oncopy="return false" onpaste="return false" oncut="return false" type="password" name="confirmpassword" class="digi-form-full-bordered" placeholder="Enter Password" v-model="confirmPassword" v-validate="'required'">
                                                <input v-else type="text" style="padding-right: 40px !important;margin-right:10px;" oncopy="return false" onpaste="return false" oncut="return false" class="digi-form-full-bordered" name="confirmpassword" placeholder="Enter Password" v-model="confirmPassword" v-validate="'required'">
                                                <span @click="showConfirmNewPassword = !showConfirmNewPassword" style="width: 18px;position: absolute;right: 35px;bottom: 9px">
                                                    <img v-if="!showConfirmNewPassword" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 18px;">
                                                    <img v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 18px;">
                                                </span>
                                            </div>
                                            <!-- <p v-if="form.password != confirmPassword && confirmPassword" class="text-danger">Passwords does not match</p> -->
                                            <p v-if="errorMessage" class="text-danger">{{errorMessage}}</p>
                                            <!-- <span class="invalid-feedback-form text-danger mb-5" style="margin-top: 4px !important;" v-show="errors.has('confirmpassword')">Please Enter Password</span> -->
                                        </div>
                                    </div>
                                    <div class="mt-10 forgot-password-button" style="text-align: center;">
                                        <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel">Cancel</button>
                                        <button class="btn newsign-in text-capitalize" @click="resetPassword">Confirm</button>
                                    </div>
                                    <!-- <span class="mt-7" style="text-align: center;">
                                        <button class="btn newcancel text-capitalize mr-4 mt-6" @click="forgotPasswordCancel">Cancel</button>
                                        <button class="btn newsign-in text-capitalize mt-6" @click="resetPassword">Confirm</button>
                                    </span> -->
                                </div>
                            </div>
                            <div v-if="activediv == 'reset successfull'" class="middle d-flex pt-5 pb-10 px-20 w-100" style="height:100%;">
                                <div class="middle-left"></div>
                                <div class="middle-right d-flex flex-column pb-10 pl-10">
                                    <img class="mb-12" style="height: 12em;" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/parrot.svg" alt="parrot">
                                    <p class="text-default-heading text-center mb-5" style="font-size: 30px; font-weight: 700;">Success</p>
                                    <p v-if="is_using_mobile" class="text-default-heading text-center mb-10" style="font-size: 18px;">Changed your password Successfully and a confirmation <br>has been sent to your phone number <span class="text-default-blue">{{form.login_id.slice(0,2)}}XXXXXX{{form.login_id.slice(-4)}}</span></p>
                                    <p v-if="is_using_email" class="text-default-heading text-center mb-10" style="font-size: 18px;">Changed your password Successfully and a confirmation <br>has been sent to your Email Address <span class="text-default-blue">{{form.login_id.slice(0,2)}}XXXXXX{{form.login_id.split("@")[0].slice(-2)}}@{{form.login_id.split("@")[1]}}</span></p>
                                    <span class="text-center">
                                        <button class="btn btn-new-primary mb-5" style="min-width: 110px; width: 160px !important;" :disabled="resend_btn_disable" @click="resetSuccessfull">OK</button>
                                    </span>
                                </div>
                            </div>
                            <!-- <span class="mt-7">
                                <button class="btn cancel mb-5">Cancel</button>
                                <button class="btn sign-in mb-5 ml-4">Submit</button>
                            </span> -->
                        </div>
                    </div>
                </div>
                <div style="position: absolute;bottom: 15px;left: 0px;right: 0px;">
                    <div class="mt-5" style="color: #fff;text-align: center;">
                        <span class="fs-14 fw-600">© Copyright 2014 - {{ new Date().getFullYear() }} DigiCollect - All Rights Reserved.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
import auth from '../mixins/auth';
import global from '../global'
import PasswordMeter from "../PasswordMeter";
export default {
    data() {
        return {
            bgCover: "background: url('/static/images/newlogin.svg') left center no-repeat;",
            loginPage: "crm",
            account_type: "Personal",
            min_pwd_length: false,
            is_uppercase_pwd: false,
            is_number_pwd: false,
            is_special_character_pwd: false,
            enter_pass_screen: false,
            sign_in_using_otp: false,
            otp_signin_btn: false,
            show_countdown: false,
            enter_email_screen: true,
            two_factor_authentication: false,
            is_two_factor_authentication: true,
            two_factor_auth_pass_screen_active: true,
            user_not_verified: false,
            is_email_phone_valid: false,
            is_email_phone_valid_text: '',
            password_error_text: '',
            login_type: '',
            login_btn_disable: false,
            resend_verification_link_success: '',
            code_resending: false,
            resend_code_success_text: '',
            otp_error_text: '',
            two_step_signed_in_otp: false,
            forget_pass_btn_disable: false,
            forgot_pass_otp_success: false,
            is_using_email: false,
            is_using_mobile: false,
            resend_btn_disable: false,
            is_email_phone_valid_text_forget_pass: '',
            ajax_progress: false,
            show_minutes: false,
            minutes_timeout_id: undefined,
            minutes: 899,
            countdownseconds: 60,
            password_button: false,
            login_id_true: false,
            oldlogin_id: true,
        }
    },
    mixins: [auth],
    components: {
        HollowDotsSpinner,
        PasswordMeter
    },
    mounted(){
        // if (this.$route.query.redirect_to) {
        //     let url = this.$route.query.redirect_to;
        //     let decode = decodeURI(url);
        //     if (decode == "https://crm.digicollect.com" || decode == "https://testcrm.digicollect.com" || decode == "http://testcrm.digicollect.com" ) {
        //         this.loginPage = "crm";
        //         this.bgCover = "background: url('https://cdn.digicollect.com/cdn/dc_crm_fe/admin_menus/crm_login.svg') left center no-repeat";
        //     } else if (decode == "https://pos.digicollect.com" || decode == "https://testpos.digicollect.com" || decode == "http://testpos.digicollect.com") {
        //         this.loginPage = "pos";
        //         this.bgCover = "background: url('https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/pos_login_new.svg') left center no-repeat";
        //     } else if (decode == "https://scm.digicollect.com" || decode == "https://testscm.digicollect.com" || decode == "http://testscm.digicollect.com") {
        //         this.loginPage = "scm";
        //         this.bgCover = "background: url('https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/scm_login_new.svg') left center no-repeat";
        //     } else if (decode == "https://hms.digicollect.com" || decode == "https://testhms.digicollect.com" || decode == "http://testhms.digicollect.com") {
        //         this.loginPage = "hms";
        //         this.bgCover = "background: url('https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hms-login-bg.svg') left center no-repeat";
        //     } else if (decode == "https://helpdesk.digicollect.com" || decode == "https://testhelpdesk.digicollect.com" || decode == "http://testhelpdesk.digicollect.com") {
        //         this.loginPage = "helpdesk";
        //         this.bgCover = "background: url('https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/helpdesk_login_new.svg') left center no-repeat";
        //     } else if (decode == "https://cloud.digicollect.com" || decode == "https://testcloud.digicollect.com" || decode == "http://testcloud.digicollect.com") {
        //         this.loginPage = "cloud";
        //         this.bgCover = "background: url('https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/cloud_login_new.svg') left center no-repeat";
        //     }
        // }
        if (this.$cookie.get("Token") && this.$route.path == '/login') {

            this.$router.push("/");
        }
    },
    created() {
        const dict = {
            custom: {
                new_password: {
                    min: () => "Minimum 8 characters",
                    regex: () => "Invalid format",
                },
            }
        };
        this.$validator.localize("en", dict);
    },
    methods: {
        checkUserIdEmpty(){
            this.login_id_true = false
            this.oldlogin_id = true
            this.form.login_id = ""
        },
        checkUserIdback(){
            this.login_id_true = false
            this.oldlogin_id = true
        },
        async loginCheckmail() {
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                this.login_type = 'email';
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_valid_text = "Please enter a valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";
                    let params = {
                        login_id: this.form.login_id
                    }
                    await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                        if(response.data.status_id == 1) {
                            this.login_id_true = true
                            this.oldlogin_id = false
                            this.form.login_id == '';
                            this.ajax_progress = false
                        }
                    }).catch((err)=>{
                        this.ajax_progress = false
                        if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                            this.enter_email_screen = false;
                            this.user_not_verified = true;
                        }else {
                            this.is_email_phone_valid = true;
                            // this.is_email_valid_text = true
                            // this.is_email_phone_valid_text = err.response.data.reason;
                            // console.log(err.response.data.reason)
                        }
                    });
                }
            } 
            // this.ajax_progress = true
            // this.otpInvalid = false;
            // this.otp_error_text = '';
            // this.password_error_text = '';
            // if (this.form.login_id.match(/[A-Za-z]/g)) {
            //     let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/);
            //     if (!check) {
            //         this.is_email_phone_valid = true;
            //         this.is_email_phone_valid_text = "Please enter a valid Email Address";
            //         this.is_email_phone_valid_text_forget_pass = ''
            //     } else {
            //         this.is_email_phone_valid = false;
            //         this.login_btn_disable = true;
            //         this.ajax_progress = true
                    
            //     }
            // }
        },
        countDownMinutes() {
            this.show_minutes = true
            if(this.countdownseconds == 0){
                this.countdownseconds = 60;
            }
            if (this.minutes > 0) {
                this.minutes_timeout_id = setTimeout(() => {
                    this.minutes -= 1;
                    this.countdownseconds -=1;
                    this.countDownMinutes();
                }, 1000);
            } else if (this.minutes === 0) {
                this.show_minutes = false
                this.countdownseconds = 0;
                this.is_using_email = false
                this.is_using_mobile = false
            }
        },
        forgotPasswordCancel(){
            if(this.form.login_id == ''){
                this.login_id_true = false
                this.oldlogin_id = true
            }
            this.activediv = 'login';
            this.enter_email_screen = true;
            this.login_btn_disable = false;
            this.enter_pass_screen = false;
            this.forget_pass_btn_disable = false;
            this.is_two_factor_authentication = true;
            this.two_factor_auth_pass_screen_active = true;
            this.two_factor_authentication = false;
            this.forgot_pass_otp_success = false;
            this.is_email_phone_valid_text_forget_pass = ''
        },
        cancelPassScreen() {
            this.enter_email_screen = true;
            this.enter_pass_screen = false;
            this.login_btn_disable = false;
        },
        cancelOtpScreen() {
            this.enter_email_screen = true;
            this.enter_pass_screen = false;
            this.sign_in_using_otp = false;
            this.login_btn_disable = false;
            this.two_factor_authentication = false;
        },
        cancelTwoFactor() {
            this.two_factor_authentication = false;
            this.enter_email_screen = true;
            this.enter_pass_screen = false;
            this.login_btn_disable = false;

        },
        checkUserId() {
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                this.login_type = 'email';
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_valid_text = "Please enter a valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";
                }
            } else {
                this.login_type = 'phone';
                let check = this.form.login_id.match(/^\d{10}$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_valid_text = "Please enter a valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";
                }
            }
        },
        goToNext(type) {
            this.ajax_progress = true
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                this.login_type = 'email';
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,50})+$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_valid_text = "Please enter a valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";
                }
            }
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,50})+$/);
                if (!check) {
                    this.is_email_phone_valid = true;
                    if(this.form.login_id == ''){
                        this.is_email_valid_text = false
                    }
                    // this.is_email_phone_valid_text = "Please enter a valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_phone_valid = false;
                    if(type == 'login') {
                        this.loginCheck();
                        this.form.password = '';
                    }
                    else {
                        this.is_using_email = true;
                        this.is_using_mobile = false;
                        this.getOtpForgetPass('send');
                    }
                }
            } else {
                // let check = this.form.login_id.match(/(\+?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/);
                let check = this.form.login_id.match(/^\d{10}$/);
                if (!check) {
                    this.is_email_phone_valid = true;
                    // this.is_email_phone_valid_text = "Please enter a valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                    this.signedIn = false;
                } else {
                    this.is_email_phone_valid = false;

                    if(type == 'login') {
                        this.loginCheck();
                        this.form.password = '';
                    }
                    else {
                        this.is_using_email = false;
                        this.is_using_mobile = true;
                        this.getOtpForgetPass('send');
                    }
                }
            }
            this.ajax_progress = false
        },
        async loginCheck() {
            this.login_btn_disable = true;
            this.ajax_progress = true
            let params = {
                login_id: this.form.login_id
            }
            await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                if(response.data.status_id == 1) {
                    this.form.login_id == '';
                    this.login_id_true = true;
                    this.oldlogin_id = false;
                    if(response.data.is_two_step_verification == true) {
                        this.two_factor_authentication = true;
                        this.enter_email_screen = false;
                    }
                    else {
                        this.enter_pass_screen = true;
                        this.enter_email_screen = false;
                    }
                    this.ajax_progress = false
                }
            }).catch((err)=>{
                this.login_btn_disable = false;
                this.ajax_progress = false
                if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                    this.enter_email_screen = false;
                    this.user_not_verified = true;
                }else {
                    this.is_email_phone_valid = true;
                    this.is_email_phone_valid_text = err.response.data.reason;
                }
                /*if(err.response.data.reason == 'Registration matching query does not exist.' || err.response.data.reason == 'Invalid Email Id or Password.') {
                    this.is_email_phone_valid = true;
                    this.is_email_phone_valid_text = 'Email Address/Phone Number not registered.';
                }*/
            });
        },
        cancelResendLink() {
            window.location.href = global.HELP_URL;
        },
        async resendUserVerifyLink() {
            this.resend_btn_disable = true;
            try {
                let params = {
                    login_id: this.form.login_id,
                }
                let response = await this.resendVerify(params);
                if(response.status_id == 1) {
                    this.resend_verification_link_success = response.response;
                    setTimeout(() => {
                        this.resend_verification_link_success = '';
                        window.location.href = global.HELP_URL;
                    }, 2000);
                }
            }
            catch(err) {
                this.resend_verification_link_success = err;
                this.resend_btn_disable = false;
            }
        },
        async loginUsingPassword(type) {
            if(this.form.password.length == 0) {
                this.password_error_text = 'Please Enter a Password';
            }
            else {
                this.signedIn = true;
                // try {
                let params = {
                    login_id: this.form.login_id,
                    password: this.form.password
                }
                await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                    this.ajax_progress = true
                    if(response.data.status_id == 1) {
                        if(type == 'one-step') {
                            if(response.data.token) {
                                this.$cookie.set("Token", response.data.token, {
                                    expires: 7,
                                    domain: "digicollect.com",
                                });
                                this.$cookie.set("session_id", response.data.session_id, {
                                    expires: 7,
                                    domain: "digicollect.com",
                                });
                                // sessionStorage.setItem('session_id', response.data.session_id);
                                if (this.$route.query.redirect_to) {
                                    window.location.href = this.$route.query.redirect_to;
                                } else {
                                    this.$store.commit("setToken", response.data.token);
                                    window.location.href = global.HELP_URL;
                                }
                            }
                            this.ajax_progress = false
                        }
                        else if(type == 'two-step') {
                            if(response.data.message == 'Please Enter Otp For Verification.' || response.data.is_two_step_verification == true) {
                                this.two_factor_auth_pass_screen_active = false;
                                this.countDownTimer();
                                 this.signedIn = false;
                            }
                            this.ajax_progress = false
                        }
                    }
                }).catch((err)=>{
                    //if(err.response.status == 400 || err.response.status == 401) {
                        this.password_error_text = err.response.data.reason;
                        this.ajax_progress = false
                        this.signedIn = false;
                        this.form.password = "";
                    //}
                });

                // }
                // catch(err) {
                //     this.password_error_text = err;
                //     this.signedIn = false;
                //     this.form.password = "";
                // }
            }
        },
        async loginUsingOtp(type) {
            if(type == 'one-step') {
                this.signedIn = true;
            }
            else {
                this.two_step_signed_in_otp = true;
            }
            let params = {
                login_id: this.form.login_id,
                otp: this.otpValue
            }
            await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                if(response.data.status_id == 1 && response.data.token) {
                    this.ajax_progress = true
                    this.$cookie.set("Token", response.data.token, {
                        expires: 7,
                        domain: "digicollect.com",
                    });
                    this.$cookie.set("session_id", response.data.session_id, {
                        expires: 7,
                        domain: "digicollect.com",
                    });
                    // sessionStorage.setItem('session_id', response.data.session_id);
                    if (this.$route.query.redirect_to) {
                        window.location.href = this.$route.query.redirect_to;
                    } else {
                        this.$store.commit("setToken", response.data.token);
                        window.location.href = global.HELP_URL;
                    }
                    this.ajax_progress = false
                }
            }).catch((err)=>{
                //if(err.response.status == 400 || err.response.status == 401) {
                    this.otpInvalid = true;
                    this.ajax_progress = false
                    this.otp_error_text = err.response.data.reason;
                    if(type == 'one-step') {
                        this.signedIn = false;
                        this.handleClearInput();
                    }
                    else {
                        this.two_step_signed_in_otp = false;
                        this.handleClearInput();
                    }
                    this.otpValue = "";
               // }
            })
        },
        handleClearInput() {
            this.$refs.otpInput.clearInput();
        },
        otpInputActive() {
            this.loginUsingPassword('two-step');
            this.password_button = false
            clearTimeout(this.minutes_timeout_id);
            this.minutes = 899;
            this.countdown = 59;
            this.countdownseconds = 60;
            this.countDownMinutes();
        },
        async goToOtpLogin(type, new_type) {
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            if(type == 'send') {
                this.sign_in_using_otp = true;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
                if(new_type && new_type =='two-factor-otp') {
                    this.password_button = true
                    this.two_factor_auth_pass_screen_active = false
                }
            }
            if(type == 'resend') {
                this.code_resending = true;
                this.otpInvalid = false;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
            }
            this.countDownTimer();

                try {
                    let params = {
                        login_id: this.form.login_id,
                        otp_for: 'login'
                    }
                    await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response) => {
                        if(response.data.status_id == 1) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.message;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        } else if(response.data.status_id == 0) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.reason;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        }
                    }).catch((err)=>{
                        if(type == 'resend') {
                            this.resend_code_success_text = err.response.data.reason;
                            setTimeout(() => {
                                this.resend_code_success_text = '';
                            }, 2000);
                            this.code_resending = false;
                        }
                    });
                }
                catch(err) {
                    if(type == 'resend') {
                        this.resend_code_success_text = err.response.data.reason;
                        setTimeout(() => {
                            this.resend_code_success_text = '';
                        }, 2000);
                        this.code_resending = false;
                    }
                }


        },
        goToPassLogin(new_type) {
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            this.sign_in_using_otp = false;
            if(new_type && new_type =='two-factor-password') {
                this.two_factor_auth_pass_screen_active = true
            }
        },
        onPassInput(e) {
            if(e.target.value.match(/^(?=.{8,}$)/)) {
                this.min_pwd_length = true;
            }
            else {
                this.min_pwd_length = false;
            }
            if(e.target.value.match(/^(?=.*[A-Z])/)) {
                this.is_uppercase_pwd = true;
            } else {
                this.is_uppercase_pwd = false;
            }
            if(e.target.value.match(/^(?=.*[0-9])/)) {
                this.is_number_pwd = true;
            } else {
                this.is_number_pwd = false;
            }
            if(e.target.value.match(/^(?=.*[!@#$%^&*()])/)) {
                this.is_special_character_pwd = true;
            } else {
                this.is_special_character_pwd = false;
            }
        },

        async getOtpForgetPass(type) {
            if(type == 'send') {
                this.forget_pass_btn_disable = true;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
            }
            else {
                this.code_resending = true;
                this.otpInvalid = false;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
            }
            this.countDownTimer();
            let params = {
                login_id: this.form.login_id,
                otp_for: 'reset'
            }
            await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response)=>{
                if(response.data.status_id == 1) {
                    this.ajax_progress = true
                    if(type == 'resend') {
                        this.resend_code_success_text = response.data.message;
                        setTimeout(() => {
                            this.resend_code_success_text = '';
                        }, 2000);
                        this.code_resending = false;
                    }
                    else {
                        this.activediv = 'verify otp';
                    }
                    this.ajax_progress = false
                }
            }).catch((err)=>{
                //if(err.response.status == 400 || err.response.status == 401) {
                    this.forget_pass_btn_disable = false;
                    this.ajax_progress = false
                    if(type == 'send') {
                        this.is_email_phone_valid_text_forget_pass = err.response.data.reason;
                    } else if(type == 'resend') {
                        this.resend_code_success_text = err.response.data.reason;
                    }
                //}
            });
        },
        async verifyOtpForgotPass() {
            this.forgot_pass_otp_success = true;
            let params = {
                login_id: this.form.login_id,
                otp: this.otpValue,
                otp_for: 'reset'
            }
            await this.$http.post(global.ADMIN_API + "/auth/otp/verify", params).then((response)=>{
                this.ajax_progress = true
                if(response.data.status_id == 1 ) {
                    this.activediv = 'set new password';
                }
                this.ajax_progress = false
            }).catch((err)=>{
                //if(err.response.status == 400 || err.response.status == 401) {
                    this.otp_error_text = err.response.data.reason;
                    this.ajax_progress = false
                    this.otpInvalid = true;
                    this.otpValue = "";
                    this.forgot_pass_otp_success = false;
                //}
            })
        },
        async resetPasswordConfirm() {
            try {
                this.ajax_progress = true
                let params = {
                    login_id: this.form.login_id,
                    password: this.form.password
                }
                let response = await this.passwordReset(params);
                if(response.status_id == 1) {
                    this.activediv = "reset successfull";
                }
                this.ajax_progress = false
            }
            catch(err) {
                this.ajax_progress = false
                this.errorMessage = err;
            }
        },
        async resetPassword() {
            this.$validator.validateAll().then(async result => {
                if (result && this.form.password && this.confirmPassword === this.form.password && !this.errorMessage) {
                    this.resetPasswordConfirm();
                } else if (!this.form.password || !this.confirmPassword) {
                    this.errorMessage = "Please fill both fields";
                } else if(this.confirmPassword !== this.form.password) {
                    this.errorMessage = "Confirm Password not Matched";
                }
            })
        }
    },
    watch: {
        "$route.path": function (path) {
            if (this.$cookie.get("Token") && path == '/login') {
                this.$router.push("/");
            }
        },
    }
}
</script>

<style scoped>
    .forgot-password{
        font-family: 'Poppins', sans-serif !important;
        font-size: 35px;
    }
    .image-holder {
        width: 500px;
        background: #fff;
        height: 500px;
        border-radius: 50%;
        bottom: -90px;
        position: absolute;
        left: -60px;
    }
    .group-image {
        width: 350px;
        height: 350px;
        right: 60px;
        position: absolute;
        top: 60px;
    }
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;
        padding-bottom: 0px;
        padding-left: 80px;
        padding-right: 80px;
    }
    .middle-left {
        width: 50%;
    }
    .middle-right {
        width: 50%;
    }
    .star {
        font-size: 12px;
        color: #F44336;
    }
    .bg-image{
        background-image: url("/static/images/login_bg1.png")left center no-repeat;
    }
    .fs-24{
        font-size: 24px;
    }
    hr {
        margin-top: 0.4rem;
        margin-bottom: 0.4rem;
        border: 0;
        border-top: 4px solid #fff;
        width: 50px !important;
        color: #fff !important;
        text-align: left !important;
        left: 0 !important;
        margin-left: 0!important;
    }
    .right-box {
        width: 89%;
        height: 100%;
        min-height: 430px;
        margin: 0 0 0.5px 50.5px;
        padding-left: 40px;
        padding-right: 40px;
        padding-top: 20px;
        padding-bottom: 20px;
        object-fit: contain;
        border-radius: 13.5px;
        -webkit-backdrop-filter: blur(20.7px);
        backdrop-filter: blur(41px);
        background-color: #ffffff1f;
    }
    .text-center{
        text-align: center !important;
    }
    .sign-in{
        width: 130px;
        height: 40px;
        /* margin: 18.5px 0 12.5px 0.5px; */
        padding: 2.5px 22px 4.5px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        color: #fff;
        font-weight: 800;
        background-image: linear-gradient(to bottom, #94bbe3, #4789cd);
    }
    .cancel{
        width: 130px;
        height: 40px;
        /* margin: 18.5px 0 12.5px 0.5px; */
        padding: 2.5px 22px 4.5px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        color: #fff;
        font-weight: 800;
        border: 1px solid #94bbe3;
        background-color: #4789cd;
    }
    .newsign-in:disabled{
        width: 130px !important;
        height: 40px !important;
        /* margin: 18.5px 0 12.5px 0.5px; */
        padding: 2.5px 22px 4.5px 22px !important;
        object-fit: contain !important;
        border-radius: 6.5px !important;
        border: 1px solid #4789cd !important;
        color: #4789cd !important;
        font-weight: 800 !important;
        border-radius: 13.5px !important;
        -webkit-backdrop-filter: blur(20.7px) !important;
        backdrop-filter: blur(41px) !important;
        font-size: 16px !important;
        background-color: #ffffff00 !important;
    }
    @media (max-width: 1270px) {
        hr{
            display: none !important;
        }
    }
    .newcancel{
        width: 130px;
        height: 40px;
        /* margin: 18.5px 0 12.5px 0.5px; */
        padding: 2.5px 22px 4.5px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        border: 1px solid #fff;
        color: #fff;
        font-weight: 800;
        border-radius: 13.5px;
        -webkit-backdrop-filter: blur(20.7px);
        backdrop-filter: blur(41px);
        background-color: #ffffff00;
        font-size: 16px !important;
    }
    .newcancel:hover{
        width: 130px;
        height: 40px;
        /* margin: 18.5px 0 12.5px 0.5px; */
        padding: 2.5px 22px 4.5px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        border: 1px solid #f4f4f4;
        color: #fff;
        font-weight: 800;
        border-radius: 13.5px;
        background-image: linear-gradient(to bottom, #94bbe3, #4789cd);
        font-size: 16px !important;
    }
    .newsign-in{
        width: 130px;
        height: 40px;
        /* margin: 18.5px 0 12.5px 0.5px; */
        padding: 2.5px 22px 4.5px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        border: 1px solid #4789cd;
        color: #fff;
        font-weight: 800;
        border-radius: 13.5px;
        background-image: linear-gradient(to bottom, #94bbe3, #4789cd);
        font-size: 16px !important;
    }
    .resend-code{
        width: 120px;
        height: 34px;
        padding: 0 0px 0 0px;
        object-fit: contain;
        border-radius: 2px !important;
        color: #00448b;
        font-weight: 800;
        border-radius: 13.5px;
        -webkit-backdrop-filter: blur(20.7px);
        backdrop-filter: blur(41px);
        background-color: #ffffff00;
    }
    @media only screen and (min-width: 0px) and (max-width: 768px){
        .newflex-reverse {
            display: flex;
            align-items: flex-start !important;
            position: relative;
            flex-direction: column-reverse !important;
        }
        .top{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding-top: 10px;
            padding-bottom: 0px;
            padding-left: 10px;
            padding-right: 10px;
        }
        .right-box{
            margin-left: 20px;
            margin-right: 20px;
        }
    }
    .bor-der::before {
        content: "";
        position: absolute;
        top: 100%;
        width: 100%;
        left: 0;
        height: 3px;
        border-radius: 2px;
        background: #fff;
    }
</style>